import { ADDTOCART } from "../allProduct/actionIdentifier";
import { MULTIPLEADD } from "../cart/actionIdentifier";

const checkStockOut = (store) => (next) => (action) => {
  if (action.type === ADDTOCART || action.type === MULTIPLEADD) {
    const allProduct = store.getState().product;
    const stockOutProducts = allProduct
      .filter((product) => product.productStock === 0)
      .map((singleProduct) => singleProduct.productId);
    if (stockOutProducts.indexOf(action.payload.id) >= 0) {
      alert("This product is stocked out!!");
      return false;
    } else {
      return next(action);
    }
  } else {
    return next(action);
  }
};

export default checkStockOut;
